/* SS · Descuento en el cajon del carrito. 15/09/2026.
   Desde mayo de 2025 el carrito AJAX admite descuentos en /cart/update.js con
   el parametro `discount`: una cadena con los codigos separados por comas, y
   cadena vacia para quitarlos todos. Es la unica via que permite tambien
   QUITAR un codigo ya puesto; la ruta /discount/ solo sabe ponerlos.
   Todo va por delegacion de eventos en document y con guarda de arranque:
   .drawer__inner se destruye y se vuelve a pintar en cada cambio del carrito,
   asi que no se puede atar ningun listener a los elementos del campo. */
(function () {
  if (window.ssDiscountInit) return;
  window.ssDiscountInit = true;

  var S = { open: false, code: '', msg: '', busy: false };

  function pick(sel) { return document.querySelector('cart-drawer ' + sel); }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function errText() {
    var n = pick('[data-ss-disc-errtext]');
    return n ? n.textContent.trim() : 'That code could not be applied';
  }

  /* Los codigos ya puestos se leen del marcado: cada aspa lleva el suyo en
     data-ss-disc-code, y el Liquid solo pinta aspa en los descuentos cuyo
     type es 'discount_code'. Los automaticos no se pueden quitar. */
  function currentCodes() {
    var out = [];
    var nodes = document.querySelectorAll('cart-drawer [data-ss-disc-code]');
    for (var i = 0; i < nodes.length; i++) {
      var c = nodes[i].getAttribute('data-ss-disc-code');
      if (c && out.indexOf(c) === -1) out.push(c);
    }
    return out;
  }

  function hasCode(cart, code) {
    var up = code.toUpperCase();
    var i, j;
    if (cart && cart.discount_codes) {
      for (i = 0; i < cart.discount_codes.length; i++) {
        var d = cart.discount_codes[i];
        if (d && d.code && d.code.toUpperCase() === up) return d.applicable !== false;
      }
    }
    if (cart && cart.cart_level_discount_applications) {
      for (i = 0; i < cart.cart_level_discount_applications.length; i++) {
        var a = cart.cart_level_discount_applications[i];
        if (a && a.title && a.title.toUpperCase() === up) return true;
      }
    }
    if (cart && cart.items) {
      for (i = 0; i < cart.items.length; i++) {
        var al = cart.items[i].line_level_discount_allocations || [];
        for (j = 0; j < al.length; j++) {
          var da = al[j].discount_application || {};
          if (da.title && da.title.toUpperCase() === up) return true;
        }
      }
    }
    return false;
  }

  function render() {
    var box = pick('[data-ss-disc]');
    if (!box) return;
    var body = box.querySelector('.ss-disc__body');
    var head = box.querySelector('[data-ss-disc-toggle]');
    var input = box.querySelector('[data-ss-disc-input]');
    var msg = box.querySelector('[data-ss-disc-msg]');
    if (body) body.hidden = !S.open;
    if (head) head.setAttribute('aria-expanded', S.open ? 'true' : 'false');
    box.classList.toggle('is-open', S.open);
    box.classList.toggle('is-busy', S.busy);
    if (input) input.value = S.code;
    if (msg) {
      msg.textContent = S.msg;
      msg.hidden = !S.msg;
    }
  }

  /* Conjunto de codigos que hay que mandar. Se pide a /cart.js porque el POST
     reemplaza la lista entera: construida solo con lo que se ve pintado, un
     codigo de envio gratis, uno de linea o uno que no llega al minimo (que no
     generan linea de descuento en el pie) se caeria del carrito sin avisar.
     El marcado queda de respaldo por si la respuesta no trae discount_codes. */
  function readCodes() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.discount_codes && cart.discount_codes.length) {
          var out = [];
          for (var i = 0; i < cart.discount_codes.length; i++) {
            var c = cart.discount_codes[i];
            /* Los no aplicables se descartan a proposito: no descuentan nada,
               no pintan linea y por tanto no llevan aspa, asi que si se
               mantuvieran el cliente se quedaria con un codigo pegado al
               carrito que no puede ver ni quitar. */
            if (c && c.code && c.applicable !== false && out.indexOf(c.code) === -1) out.push(c.code);
          }
          return out;
        }
        return currentCodes();
      })
      .catch(function () { return currentCodes(); });
  }

  function post(codes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  /* Se reemplaza .drawer__inner entero y no solo el pie: asi se repinta
     tambien la barra de envio gratis, que vive por encima y si no se
     quedaria diciendo ENVIO GRATIS con un total ya rebajado. */
  function refresh() {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : root() + 'cart';
    return fetch(base + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var t = document.querySelector('.drawer__inner');
        var s = doc.querySelector('.drawer__inner');
        if (t && s) t.replaceWith(s);
      });
  }

  function apply() {
    if (S.busy) return;
    var box = pick('[data-ss-disc]');
    if (!box) return;
    var input = box.querySelector('[data-ss-disc-input]');
    var code = ((input && input.value) || '').trim();
    if (!code) return;
    S.code = code;
    S.busy = true;
    S.msg = '';
    render();
    var prev = [];
    readCodes()
      .then(function (codes) {
        var dup = false;
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].toUpperCase() === code.toUpperCase()) dup = true;
          prev.push(codes[i]);
        }
        if (!dup) codes.push(code);
        return post(codes);
      })
      .then(function (cart) {
        if (hasCode(cart, code)) {
          return refresh().then(function () {
            S.busy = false;
            S.code = '';
            S.msg = '';
            S.open = false;
            render();
          });
        }
        /* El codigo no ha descontado nada, asi que se deshace y se deja el
           carrito con los codigos que tenia. Si no, se queda pegado: un codigo
           no aplicable no pinta linea de descuento, no lleva aspa y el cliente
           no tiene forma de quitarlo. */
        return post(prev).then(refresh).then(function () {
          S.busy = false;
          S.msg = errText();
          render();
        });
      })
      .catch(function () {
        /* Si algo se ha caido a mitad, se repinta desde el servidor y se vuelve
           a aplicar el estado ENCIMA del HTML nuevo: asi el cliente ve el
           carrito de verdad sin perder el mensaje de error. El render tiene que
           ir despues del refresh, no antes, porque el refresh reemplaza el nodo
           del mensaje por uno vacio y oculto. */
        S.busy = false;
        S.msg = errText();
        return refresh().then(function () { render(); }, function () { render(); });
      });
  }

  function drop(code) {
    if (S.busy || !code) return;
    S.busy = true;
    S.msg = '';
    render();
    readCodes()
      .then(function (all) {
        var left = [];
        for (var i = 0; i < all.length; i++) {
          if (all[i].toUpperCase() !== code.toUpperCase()) left.push(all[i]);
        }
        return post(left);
      })
      .then(refresh)
      .then(function () { S.busy = false; render(); })
      .catch(function () { S.busy = false; render(); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var rm = e.target.closest('.ss-disc__rm');
    if (rm) {
      e.preventDefault();
      drop(rm.getAttribute('data-ss-disc-code'));
      return;
    }
    if (e.target.closest('[data-ss-disc-toggle]')) {
      e.preventDefault();
      S.open = !S.open;
      render();
      var i = pick('[data-ss-disc-input]');
      if (S.open && i) i.focus();
      return;
    }
    if (e.target.closest('[data-ss-disc-apply]')) {
      e.preventDefault();
      apply();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.matches && e.target.matches('[data-ss-disc-input]')) {
      e.preventDefault();
      apply();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-ss-disc-input]')) S.code = e.target.value;
  });
})();
